import { useEditMcpServerMutation, type McpServer } from '@generated/graphql';
import posthog from 'posthog-js';

type ToggleMcpServerProps = {
  server: Pick<McpServer, 'mcpServerId' | 'enabled'>;
  onChange?: VoidFunction;
};

export const useToggleMcpServer = ({ server, onChange }: ToggleMcpServerProps) => {
  const [toggleMcpServer] = useEditMcpServerMutation();

  return async () => {
    posthog.capture('agent-studio:user_toggle-mcp-server-auto-enable_submitted', {
      mcpServerId: server.mcpServerId,
      enabled: !server.enabled,
    });
    await toggleMcpServer({
      variables: { mcpServerId: server.mcpServerId, enabled: !server.enabled },
      onCompleted: () => {
        posthog.capture('agent-studio:user_toggle-mcp-server-auto-enable_completed', {
          mcpServerId: server.mcpServerId,
          enabled: !server.enabled,
        });
        onChange?.();
      },
      onError: (error) => {
        posthog.capture('agent-studio:user_toggle-mcp-server-auto-enable_failed', {
          mcpServerId: server.mcpServerId,
          error: (error as Error)?.message || 'An error occurred during toggle',
        });
      },
    });
  };
};
